<script>
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import SuppliersApi from "@/services/suppliers-api";
import ItemsApi from "@/services/items-api";
import LocalInvoicesApi from "@/services/local-invoices-api";
import CustomerApi from "@/services/customers-api";


export default {
  page: {
    title: "Facture",
    meta: [{ name: "description", content: appConfig.description }]
  },

  props: {
    localInvoiceId: {
      type: Number,
      default: 0,
    },
    isCatalogList: {
      type: Boolean,
      default: false,
    },
    showTransfer:{
      type: Boolean,
      default:null
    }
  },

  watch: {
        
         dueDate : function(){
          this.editLocalInvoice()
         },
 
         selected : function(){
          this.loadUser(this.selected)
         },
      
         selectedItem: function() {
            this.selectedItems = this.selectedItem ? this.selectedItem.id : null
            this.getItem(this.selectedItems ,this.localInvoice.supplier.id)
        }, 
      
      'localInvoiceId': function(){
        this.getInvoice();
    }
  },

  components: { },
  data() {
    return {
      isDesktop: window.innerWidth >= 800 ,

      localInvoice : {lines:[], supplier:{city:{}, country:{}}, customer:{city:{}, country:{}},},
      invoiceLine: {reference:'', title: '', price: '', description:'',quantity:'', vatPercent :'' , discount :'' , taxPercent:''},
      itemLines: [],
      invoice:{dueDate:''},

      itemFields: [
        {key:"actions", label:""},
        { key:"title", label: "Article", sortable: true, tdClass:"p-0"},
        { key:"ref", label: "Réference", sortable: false, tdClass:"p-0"},
        { key:"price", label: "P.U (TND)", sortable: false, tdClass:"text-right font-weight-bold", thClass:"text-right", thStyle:"width:150px"},
        { key:"discount", label: "remise (TND)", sortable: false, tdClass:"text-right font-weight-bold", thClass:"text-right", thStyle:"width:150px"},
        { key:"discountedPrice", label: "P.U.Remisé (TND)", sortable: false, tdClass:"text-right font-weight-bold", thClass:"text-right", thStyle:"width:100px"},
      ],

      selected:null,
      selectedItem: null ,
      selectedItems: null ,

      showCarrierModal: false,
      isOrderPending: false,
      role: null,

      usersList:[],
      paymentMode: [
        { value: true, label: "Paiement au comptant" },
        { value: false, label: "Paiement à échéance" }
      ],
      
       user: {
        taxRefNumber:'',
        name:'',
        address:'',
        city: {name:''},
        country: {name:''}
      },

        itemsFilter: '',

        pagemodelMain: {currentPage : 1, perPage : 15, totalRows: 0},
        isItemsTableBusy: false,
        endOfFindItems:false,
        itemsList: [],
        item:null,
        customerId : null ,
        showModal:false ,
        formError:false,
        isAddToInvoiceStarting:false,
        selectedPaymentType:"",
        dueDate:"",
        showDescription: 0,

        isCustomerListLoading: false,
       

    };
  },  
  
    mounted() {
    this.getCustomers()
    window.addEventListener('resize', this.handleResize);
    this.findItems( )
    this.getInvoice();
    this.role=sessionStorage.getItem("userr");

  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },


    methods: {
      handleResize() { this.isDesktop = window.innerWidth >= 992; },


      validerLocalInvoice() {
      Swal.fire({
        title: "Valider la facture ?",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Oui, Valider !",

      })
      
      .then(result => {
        const  localInvoice= {
        invoiceId : this.localInvoiceId, 
        customerId: this.selected.id,
        supplierId: this.localInvoice.supplier.id,
        isSupplier:this.selected.isSupplier ,
        dueDate: this.dueDate,
      }
        if (result.value) {
          LocalInvoicesApi.submitLocalInvoice(localInvoice)
            .then((order) => {
              if (order) {
                this.order = order;
                this.$router.push({ path: '/local-invoices/get', query: { localInvoiceId: this.localInvoiceId } });

              }
            })
        }
      });
    },
        removeLocalInvoiceLine(item){
            const LocalInvoiceLine= {
              localInvoiceLineId :item.id,
              invoiceId : this.localInvoiceId,  
           } 

          Swal.fire({
          title: "Supprimer ?",
          html: item.itemTitle,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          cancelButtonText: "Annuler",
          confirmButtonText: "Oui, supprimer!"
          }).then(result => {
          if (result.value) {
            LocalInvoicesApi.removeLocalInvoiceLine(LocalInvoiceLine)
            .then(invoice => {
              if (!invoice) {
                this.clearAll()
              } else {
                this.invoiceLine = invoice.lines;
                this.invoice = invoice;
                this.getInvoice()
              }
            })
          }
          });
          },

      editLocalInvoice() {
       const  localInvoice= {
        invoiceId : this.localInvoiceId, 
        customerId: this.selected.id,
        supplierId: this.localInvoice.supplier.id,
        isSupplier: this.selected.isSupplier ,
        dueDate: this.dueDate,
      }
      
      this.isaddToInvoiceStarting=true
      LocalInvoicesApi.editLocalInvoice(localInvoice) 
      .then(invoice => {
        if(invoice) {
          this.invoiceLines = invoice.lines;
          this.invoice = invoice; 
          this.localInvoiceId = invoice.id;

        }
        }).then(()=>{
          this.isaddToInvoiceStarting=false
        }).finally(()=>{
          this.isaddToInvoiceStarting=false
        })
    },

    addLineToInvoice() {
      const LocalInvoiceLine= {
       localInvoiceLineId: this.invoiceLine.id,
       reference :this.invoiceLine.reference,
       invoiceId : this.localInvoiceId, 
       itemTitle: this.invoiceLine.title , 
       price: this.invoiceLine.price , 
       discount: this.invoiceLine.discount , 
       quantity: parseInt(this.invoiceLine.quantity), 
       vatPercent: this.invoiceLine.vatPercent,
       taxPercent: this.invoiceLine.taxPercent,
       description:this.invoiceLine.description
    
      } 

      this.isAddToInvoiceStarting=true
        LocalInvoicesApi.addLineToInvoice(LocalInvoiceLine ) 
      .then(invoice => {
        if(invoice) {
          this.invoiceLine = invoice.lines;
          this.localInvoice = invoice; 
          this.localInvoiceId = invoice.id;
        }
        })
    },
      
      showitemModal(){
      this.showModal=true;
      this.formError=false
    },

      getItem(itemId , customerId ){
        ItemsApi.getItem(itemId , customerId).then(
          response =>{
            this.item=response
          }

        )

      },

      loadUser(selected){
        if (selected == null) {
          return;
        }

        if(this.selected.isSupplier){          
            this.loadSupplier(selected.id)
            this.editLocalInvoice()
            
          }else{
            this.loadCustomer(selected.id)
            this.editLocalInvoice()
          }

      },


       loadSupplier(selectedUserId) {
       
        SuppliersApi.loadSupplier(selectedUserId) 
        .then(supplier => {
            this.user = supplier;
          })
        },

        loadCustomer(selectedUserId) {
       
          CustomerApi.loadCustomer(selectedUserId) 
       .then(customer => {
           this.user = customer;
         })
       },


      getCustomers(){

        this.isCustomerListLoading = true;
        LocalInvoicesApi.findAllCustomersAndSuppliers().then(
              response => {    
                this.usersList = response;
                this.isCustomerListLoading = false;
              }
          )
          .finally(() => {
              this.isCustomerListLoading = false;
          });

      },


    findItems() {
    this.isItemsTableBusy = true;
    ItemsApi.findItemsSupplier(this.itemsFilter, this.pagemodelMain.currentPage, this.pagemodelMain.perPage)
      .then(itemsList => {
    
        this.itemLines=itemsList.list ;
        this.pagemodelMain.totalRows = itemsList.total;
        this.pagemodelMain.currentPage = itemsList.page;
        this.pagemodelMain.perPage = itemsList.pageSize;
        this.pagemodelMain.pageSize = itemsList.pageSize;
      })
      .finally(() => {
        this.isItemsTableBusy = false;
        this.endOfFindItems = true;
      });
  },

    addItems(item){

      this.invoiceLine.reference = item.ref
      this.invoiceLine.title = item.title
      this.invoiceLine.discountedPrice = item.discountedPrice
      this.invoiceLine.price = item.priceAsFloat
      this.invoiceLine.discount = item.discount
      this.invoiceLine.vatPercent = item.vatPercent
      this.invoiceLine.taxPercent = item.taxPercent
      this.invoiceLine.quantity = 1
      this.invoiceLine.priceAfterDiscount =""
      this.invoiceLine.priceHt =""
      this.showModal=false
      
    },

    getInvoice() {
      LocalInvoicesApi.get(this.localInvoiceId)
      .then(invoice => {
        this.localInvoice = invoice;
        this.selected = this.localInvoice.customer
        
    })

      .finally(() => {
      })
    },

  
    priorityToLabel(priority) {
      switch(priority) {
        case 0: return 'Basse';
        case 1: return 'Normale';
        case 2: return 'Urgente';
        default: return 'Normale';
      }
    },

    priorityToColor(priority) {
      switch(priority) {
        case 0: return 'success';
        case 1: return 'secondary';
        case 2: return 'danger';
        default: return 'sacondary';
      }
    },

    statusToLabel(order) {
      if (order == null || order.status == null) {
        return '';
      }

      switch(order.status) {
        case 0: return 'Brouillon';
        case 1: return 'Nouvelle';
        case 2: return 'Confirmée'
        case 3: return order.isDeliveryDone ? 'Livré' : 'En cours de Livraison';
        case 4: return 'Annulée';
        default: return '';
      }
    },

    statusToColor(order) {
      switch(order.status) {
        case 0: return 'secondary';
        case 1: return 'danger';
        case 2: return 'warning';
        case 3: return order.isDeliveryDone ? 'success' : 'info';
        case 4: return 'secondary';
        default: return 'black';
      }
    },

  }

}

</script>



<template>
<div>
    <div v-if="!isCatalogList" class="row pt-4  d-print-none">
      

      <div class="col-md-6 col-sm-12 text-left " >
        <div class="form-group mb-3">
          <label>Etat de la Facture</label><br>

          <h5><b-badge href="#" :variant="statusToColor(localInvoice)">{{statusToLabel(localInvoice)}}</b-badge></h5>
         
        </div>
      </div>

    </div>
    
  
    <div class="row " v-if="!showCarrierModal">

      
      
      <div class="col-12">

        
        <div class="card border border-secondary no-border-on-print">
          <div class="card-body">
            <div  class="invoice-title">
              <h4 class="float-right text-primary font-size-16">BON DE COMMANDE N° <strong>{{localInvoice.ref}}</strong></h4>
              <div class="mb-4">
                <img v-bind:src="'/api/image/get/' + localInvoice.supplier.logo" alt="logo" height="40" />


                <!-- <img v-bind:src="'/api/image/get/' + order.supplier.logo" alt class="avatar-sm" style="height: 4rem;width: 7rem;border: 1px solid #a09999;padding: 10px;" /> -->



              </div>
            </div>
            <hr class="d-print-none" />
           
            <div class="row">
              <div  class="col-6">
                <address>
                  <strong>Fournisseur :</strong> {{this.localInvoice.supplier.legalName}}
                  <br />{{this.localInvoice.supplier.address}}
                  <br />{{ this.localInvoice.supplier ? this.localInvoice.supplier.city.name : ''}}, {{this.localInvoice.supplier ? this.localInvoice.supplier.country.name : ''}}
                  <br/><br /><i v-if="localInvoice.supplier.phone" class="fas fa-phone text-muted font-size-12"/> {{this.localInvoice.supplier.phone}}
                  <span v-if="localInvoice.supplier.secondPhone" class="font-size-12"> - {{this.localInvoice.supplier.secondPhone}}</span>
                  
                  <br />
                </address>
              </div>
              <div :class="{'col-lg-4 col-12 text-right pt-1 pr-1': isDesktop, 'col-12 text-left pt-1 pl-1': !isDesktop}">

                  <strong>Client : </strong> </div>   
                 
              <div class="col-lg-2 col-12 text-right ">

                <b-spinner v-if="isCustomerListLoading" small ></b-spinner>

                <address>
                  
                   <v-select    v-if="!isCustomerListLoading"
                   class="style-vselect text-info-important font-weight-bold font-size-14 " 
                   v-model="selected" 
                   :options="usersList" 
                   placeholder="Sélectionner un client" 
                   label="name" >
                  
                 
                      <span slot="no-options">Client</span> 
                  </v-select> 
                  <br />{{this.user ? this.user.name : ''}}
                  <br />{{this.user ? this.user.city.name : ''}} - {{this.localInvoice.customer.country.name}}
                  <br /><i>{{this.user && this.user.taxRefNumber ? 'MF : ' + this.user.taxRefNumber : ''}} </i>
                  <br/><br /><i v-if="user && user.phone" class="fas fa-phone text-muted font-size-12"/> {{this.user ? this.user.phone : ''}}
                  <span v-if="user && user.secondPhone" class="font-size-12"> - {{this.user ?  this.user.secondPhone : ''}}</span>
                </address>
              </div>
            </div>
            <div class="row">
              <div class="col-6 mt-3">
                <address>
                  <strong>Date:</strong>
                  <br />{{localInvoice.date}}
                  </address>
              </div>
              <div class="col-6 mt-3 text-right">
                <address>
                  <strong>Adresse de Livraison :</strong>
                  <br />{{this.user ? this.user.address : ''}}
                </address>
              </div>
            </div> 
            <address>
                  <strong>Date d'Echeance:</strong>
                  <br />{{this.invoice.dueDate }}
                  </address>
            <div class="col">
                  <div class="col-lg-2 col-12 pt-1 style-vselect text-info-important font-weight-bold font-size-14 ">
                      <v-select v-model="selectedPaymentType"
                      :options="paymentMode"
                      item-text="label" 
                      item-value="value"
                      placeholder="Mode de paiment"
                      >
                      </v-select>
                  </div>
            
                
                  <b-form-datepicker
                  class="col-2 mt-2  " v-if="this.selectedPaymentType.value == false "
                    v-model="dueDate"
                    right
                    locale="fr"
                    label-no-date-selected="Date Echeance"
                    dark
                  ></b-form-datepicker>
               
            </div>

            <div class="p-2 mt-3">
              <h3 class="font-size-16">Commande</h3>
            </div>
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th style="min-width: 150px;">Référence</th>
                    <th style="min-width: 480px;">Article</th>
                    <th style="min-width: 120px;" class="text-right">P.U</th>
                    <th style="min-width: 70px;" class="text-right">Remise</th>
                    <th style="min-width: 120px;" class="text-right">P.U Remisé</th>
                    <th style="min-width: 90px; " class="text-right">Qté </th>
                    <th style="min-width: 70px; " class="text-right">Taxe </th>
                    <th style="min-width: 70px; " class="text-right">TVA </th>
                    <th style="min-width: 120px; " class="text-right">Total HT</th>
                    <th style="width: 150px;" class="text-right">Total Remisé HT</th>
                    <th style="width:70px;"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <b-form-input placeholder="Réferance"  v-model="invoiceLine.reference" ></b-form-input>   
                    </td>

                    <td>
                      <div class="row">
                        <b-form-input placeholder="Désignation"  v-model="invoiceLine.title" class="col-11" ></b-form-input> 
                        <i class="col-1 fas fa-upload font-size-20 align-middle pl-3 pt-2" style="cursor:pointer ;" @click="showitemModal() ;findItems()"></i>
                      </div>  

                      <div class="row pt-1">
                        <div class="col-11">
                          <b-form-checkbox
                              value="1" class="pb-2"
                              unchecked-value="0"
                              v-model="showDescription">
                            <span class="text-muted font-size-12" > <i>Ajouter description de l'article</i></span>
                          </b-form-checkbox>

                          <textarea v-if="showDescription == 1" placeholder="Description" rows="2"  v-model="invoiceLine.description" class="w-100 text-muted font-size-12 p-2"
                          style="border:1px solid #ced4da" ></textarea> 

                        </div>  
                      </div>
                    </td>

                    <td>
                      <b-form-input placeholder="P.U" class="text-right"  v-model="invoiceLine.price" ></b-form-input>   
                    </td>

                    <td>
                      <b-form-input class="text-right" placeholder="%"  v-model="invoiceLine.discount"  ></b-form-input> 
                    </td>

                     <!-- Empty for discounted price-->
                     <td></td>

                    <td>
                      <b-form-input placeholder="Qté" class="text-right"  v-model="invoiceLine.quantity" ></b-form-input>                          
                    </td>
                    
                    <td>
                      <b-form-input placeholder="%" class="text-right"  v-model="invoiceLine.taxPercent"  ></b-form-input> 
                    </td>

                    <td>
                      <b-form-input placeholder="%" class="text-right"  v-model="invoiceLine.vatPercent" ></b-form-input>                             
                    </td>

                    <!-- Empty for Total TTC-->
                    <td></td>

                     <!-- Empty for Total Net-->
                     <td></td>

                     <td class=" text-right">
                          <i class="fas fa-plus font-size-20 align-middle" @click="addLineToInvoice()" style="cursor:pointer;"></i>
                      </td> 

                  </tr>
                  
                    <tr v-for="(line,i) in this.localInvoice.lines" :key="i">
                      <td class=" text-left pl-4" >{{line.ref}}</td> 
                     
                      <td class=" text-left pl-4" >

                        <span class="text-dark font-weight-bold">{{ line.itemTitle }}</span>
                        <p v-if="line.description" class="m-0 pt-1 text-muted font-size-12"><i> {{ line.description }} </i></p>
                      
                    </td> 
                      <td class=" text-right pl-4">{{ line.price }}</td> 
                      <td class=" text-right pl-4">{{ line.discountRateStr }}</td> 
                      <td class=" text-right pl-4">{{ line.discountedPrice }}</td> 
                      <td class=" text-right pl-4">{{ line.quantity }}</td> 
                      <td class=" text-right pl-4">{{ line.taxPercent }}</td> 
                      <td class=" text-right pl-4">{{ line.vatPercent }}</td> 
                      <td class=" text-right pl-4">{{ line.lineTotalAmountBeforeDiscountStr }}</td> 
                      
                     
                      <td class=" text-right">
                            {{ line.lineTotalAmount }}
                      </td> 
                      
                      <td class=" text-right">
                          <i class="mdi mdi-trash-can font-size-22 align-middle" style="cursor: pointer;" @click="removeLocalInvoiceLine(line)"></i>
                      </td> 

                    </tr>


                    <tr>
                    <td colspan="9" class="border-0 text-right">
                      <h5 class="m-0">Total HT</h5>
                    </td>
                    <td colspan="11" class="border-0 text-right">
                      <h5 class="m-0">{{this.localInvoice.total}} TND</h5>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="9" class="border-0 text-right">
                      <strong>Taxes</strong>
                    </td>
                    <td colspan="11" class="border-0 text-right">
                      <span class="m-0">{{this.localInvoice.taxes}} TND</span>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="9" class="border-0 text-right">
                      <strong>T.V.A.</strong>
                    </td>
                    <td colspan="11" class="border-0 text-right">
                      <span class="m-0">{{this.localInvoice.vat}} TND</span>
                    </td>
                  </tr>

                <tr v-if=" localInvoice.isTaxStampEnabled">
                  <td  colspan="9" class="border-0 text-right">
                    <strong>Timbre Fiscal</strong>
                  </td>
                  <td colspan="11" class="border-0 text-right">
                    <span class="m-0">{{localInvoice.taxStamp}} TND</span>
                  </td>
                </tr>

                  <tr>
                    <td colspan="9" class="border-0 text-right">
                      <h5 class="m-0">Total TTC</h5>
                    </td>
                    <td colspan="11" class="border-0 text-right">
                      <h5 class="m-0">{{this.localInvoice.totalWithTaxes}} TND</h5>
                    </td>
                  </tr>
    

                </tbody>
              </table>
              
            </div> 
          </div>
        </div>
      </div>
    </div>

 <div class="row pt-4 pb-4" v-if="!showCarrierModal">
      
      <div class="col-md-2 col-sm-4 p-1 text-right d-print-none" > 
        <a href="javascript:window.print()">
            <!-- <b-button variant="light" style="width: 100%" size="lg" v-if="!isCatalogList" >
                  <i class="fa fa-print font-size-16 align-middle mr-2"></i> Imprimer
            </b-button> -->
          </a>
      </div>

      <div class="col-md-2 col-sm-4 p-1 text-right d-print-none" > 
          <!--b-button variant="light" style="width: 100%" size="lg" @click.prevent="exportEXCEL(localInvoiceId)"  v-if="!isCatalogList" >
                <i class="fas fa-file-excel font-size-16 align-middle mr-2"></i> Exporter
          </b-button-->
      </div>

     <div class="col-md-2 col-sm-4 p-1 text-right d-print-none" />  
     <div class="col-md-2 col-sm-4 p-1 text-right position-right d-print-none"> </div>
     <div class="col-md-2 col-sm-4 p-1 text-right d-print-none"></div>

     <div class="col-md-2 col-sm-4 p-1 text-right position-right d-print-none">
                <b-button variant="success" style="width: 100%" size="lg" @click="validerLocalInvoice"   :disabled="localInvoice.status == 2 " >
                        <i class="fas fa-check font-size-16 align-middle mr-2"></i> Valider
                    </b-button>
                  </div>
 
      <!-- <div class="col-md-2 col-sm-4 p-1 text-right d-print-none">
        <b-button variant="secondary" style="width: 100%" size="lg"  :disabled="localInvoice.status == 0" v-if="!isCatalogList" >
                <i class="fas fa-exclamation-triangle font-size-16 align-middle mr-2"></i> Annuler
            </b-button>
      </div>  -->


    </div>

   

<!--      item modal
 -->    
 <b-modal v-model="showModal" 
      title="Liste des Articles" 
      centered no-footer
      title-tag="h5"
      header-close-variant="danger"
      title-class="text-warning"
      size="xl">
        <div class=" zoom-container">


          <b-input-group  >
            <b-form-input placeholder="Chercher par Référence ou Désignation ou Marque"  v-model="itemsFilter"   @keyup.native.enter="findItems()"
                ></b-form-input>                              
            <template v-slot:append>
                <b-button variant="success" @click="findItems()">
                <i class="bx bx-search-alt font-size-16 align-middle"></i>
                </b-button>
            </template>
          </b-input-group>


          <div class="col">
          <b-table
            :striped="true"
            :small="true"
            :hover="true"
            :items="itemLines"
            :fields="itemFields"
            sortKey="itemTitle"
            responsive
            class="col-12 p-3"
          > 
          <template v-slot:cell(actions)="{item}">
              <a  title="Ajouter" href="javascript:void(0);"  @click="addItems(item)" :class="item.id ? '' : 'd-none'" class="action-icon text-primary">
                <i class="fas fa-plus-circle font-size-18" />
              </a>  
        </template>
                             
        </b-table>
        <!--Pagination-->         
            <div class="col-12">
                  <div class="row">
                    <div class="col-8">
                        <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                            <b-form-select @input="findItems()"  v-model="pagemodelMain.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                            <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">sur</span><span class="font-weight-bold"> {{pagemodelMain.totalRows}} lignes</span></div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="dataTables_paginate paging_simple_numbers float-right">
                            <ul class="pagination pagination-rounded mb-0">
                            <b-pagination v-model="pagemodelMain.currentPage" :disabled="isItemsTableBusy" :per-page="pagemodelMain.pageSize" :total-rows="pagemodelMain.totalRows" @input="findItems()" ></b-pagination>
                            </ul>
                        </div>
                    </div>
                  </div>
              </div> 
          <!--Fin Pagination-->         
        </div>

      </div>

        <template v-slot:modal-footer>
          <b-button class="zoom-container" variant="secondary" @click="showModal=false" size="md">Annuler</b-button>
        </template> 
      </b-modal>

</div>
</template>